<template>
  <b-carousel class="custom-carousel" v-model="slide" indicators controls>
    <b-carousel-slide v-for="(slide, index) in slides" :key="index">
      <template v-slot:img>
        <div class="custom-carousel__slide text-center">
          <b-img-lazy :src="slide.image"></b-img-lazy>
          <h2 class="mb-3">{{ slide.title }}</h2>
          <p>{{ slide.desc }}</p>
        </div>
      </template>
    </b-carousel-slide>
  </b-carousel>
</template>
<script>
/**
 * ==================================================================================
 * Carousel component
 * ==================================================================================
 **/

export default {
  props: {
    slides: {
      type: Array,
      default: () => []
    }
  },
  data: function() {
    return {
      slide: 0
    }
  }
}
</script>
<style scoped lang="scss">
.custom-carousel /deep/ {
  width: 400px;
  text-align: center;

  .custom-carousel__slide {
    img {
      width: 175px;
      margin-bottom: 70px;
    }

    h2,
    p {
      max-width: 300px;
      margin: 0 auto;
    }

    p {
      line-height: 1.1rem;
    }
  }

  .carousel-control-prev,
  .carousel-control-next {
    top: auto;
    bottom: 6px;
    opacity: 1;
    z-index: 1000;
  }

  .carousel-control-prev {
    left: 0;
    > span {
      background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%212529' width='23' height='23' viewBox='0 0 32 32'%3e%3cpath d='M11.975,13.686a1.706,1.706,0,0,1-1.209-.5L.5,2.92A1.71,1.71,0,0,1,2.92.5l9.054,9.054L21.029.5A1.71,1.71,0,0,1,23.448,2.92L13.184,13.184A1.706,1.706,0,0,1,11.975,13.686Z' transform='translate(22.685 4) rotate(90)' /%3e%3c/svg%3e");
    }
  }

  .carousel-control-next {
    right: 0;
    > span {
      background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%212529' width='23' height='23' viewBox='0 0 32 32'%3e%3cpath d='M11.975,0a1.706,1.706,0,0,0-1.209.5L.5,10.765A1.71,1.71,0,0,0,2.92,13.184l9.054-9.054,9.054,9.054a1.71,1.71,0,0,0,2.419-2.419L13.184.5A1.706,1.706,0,0,0,11.975,0Z' transform='translate(22.685 4) rotate(90)' /%3e%3c/svg%3e");
    }
  }

  .carousel-indicators {
    width: 100%;
    position: relative;
    margin: 60px auto 0 auto;

    li {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      margin: 0 10px;
      outline: none;
      background-color: var(--input-border-color);
    }

    li.active {
      background-color: var(--brand-green);
    }
  }
}
</style>
